// Components
import App from "./App.vue";

// Composables
import { createApp } from "vue";

// Plugins
import { registerPlugins } from "@/plugins";
import { Can, abilitiesPlugin } from "@casl/vue";
import userStore from "@/store/user";
import router from "./router";
import pinia from "./store";

import { aplicarTokensCor } from "@/design/tokens";

import "./main.scss";

import * as Sentry from "@sentry/vue";
import config from "./config";

const app: any = createApp(App);

Sentry.init({
  app,
  dsn: config.SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: config.AMBIENTE,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
    Sentry.vueIntegration({
      tracingOptions: {
        trackComponents: true,
        // OR
        // trackComponents: [
        //     "App",
        //     "RwvHeader",
        //     "RwvFooter",
        //     "RwvArticleList",
        //     "Pagination",
        // ],
      },
    }),
  ],
  // Tracing
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", config.API_DOMAIN],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Logs
  enableLogs: true,
  // Filtragem de ruído (Best Practice para projetos antigos)
  beforeSend(event: any, hint: any) {
    const error = hint.originalException;
    // Exemplo: Ignorar erros chatos de extensões ou rede
    if (error && error.toString().includes("ResizeObserver loop limit exceeded")) {
      return null;
    }
    return event;
  },
});

registerPlugins(app);

const user = userStore();
user.defineAbilities();
app
  .use(abilitiesPlugin, user.ability, {
    useGlobalProperties: true,
  })
  .component(Can.name, Can);
app.config.devtools = true;

// Publica os tokens de cor em `:root` antes do primeiro paint: o CSS global
// consome com `var(--gali-cor-primaria)`.
aplicarTokensCor();

app.mount("#app");
